export const contentOwnership = `
  # Needed for index page
  id
  title

  # Needed for basic validity
  description
  shortDescription
  developers
  headsetHtcVive,
  headsetOculusRift,
  headsetWindowsMr,
  headsetValveIndex,
  experienceType
  difficulty
  imageUrl
  videoMp4Url
  developerSupportEmail
  systemRequirements
  genres {
    id
    title
  }

  # Needed for player validity
  multiplayer
  maxPlayers
  minPlayers
  singleplayer

  # Needed for price validity
  basePriceMinute
  minutePrice {
    current {
      price
      startsAt
      endsAt
    }
    upcoming {
      price
      startsAt
      endsAt
    }
  }
  basePriceMonth
  regionalPricing
  disablePriceMonth
  monthlyPrice {
    current {
      price
      startsAt
      endsAt
    }
    upcoming {
      price
      startsAt
      endsAt
    }
  }
  basePriceYear
  disablePriceYear
  yearlyPrice {
    current {
      price
      startsAt
      endsAt
    }
    upcoming {
      price
      startsAt
      endsAt
    }
  }
  basePricePlay
  upcomingPrices {
    id
    priceMinute
    distribute
  }

  # Needed for CDS validity
  cds
  status
  approvalStatus

  # Needed for EULA Validity
  currentAgreement {
    content
  }
  upcomingAgreement {
    content
  }

  # Needed for Keys Validity
  freeDownload
  keysTotal
  bundle {
    id
  }
`;

export const contentOwnershipWithKeys = `
  id
  freeDownload
  keysAvailable
  keysUsed
  keysTotal
  keysRequested
`;

export const contentOwnershipDetails = `
  id
  status
  approvalStatus
  title
  embedCode
  imageUrl
  videoMp4Url
  videoWebmUrl
  gameplayVideoMp4Url
  gameplayVideoWebmUrl

  steamId

  contentOwnershipLanguages {
    language
    displayLanguage
    interface
    fullAudio
    subtitles
  }

  freeDownload
  keysAvailable
  keysUsed
  keysTotal
  keysRequested

  cds

  ageRating
  contentTarget
  drm
  developers
  publishers
  description
  shortDescription
  developerSupportEmail
  systemRequirements
  difficulty
  headsetHtcVive
  headsetOculusRift
  headsetWindowsMr
  headsetValveIndex
  experienceType
  singleplayer
  multiplayer
  minPlayers
  maxPlayers

  genres {
    id
    title
  }

  regionalPricing
  newPriceChangeDate
  basePriceMinute
  basePriceMonth
  basePriceYear

  currentPrices {
    id
    priceMinute
    priceMinuteOverride
    priceMonth
    priceMonthOverride
    priceYear
    priceYearOverride
    distribute
    country
  }
  upcomingPrices {
    id
    priceMinute
    priceMinuteOverride
    priceMonth
    priceMonthOverride
    priceYear
    priceYearOverride
    pricePlay
    pricePlayOverride
    durationPlay
    distribute
    startsAt
    country
  }

  currentAgreement {
    content
    startsAt
  }
  upcomingAgreement {
    content
    startsAt
  }

  updateNotes
  freeForOnTrial
`;
